// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"1":"cb9d3111","235":"8ba03de1","347":"35f98a35","425":"0e34116d","594":"5a90a14c","855":"59fe0926","985":"2125c58f"}[chunkId] + ".css";
};